import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useSmartEntity } from 'contexts/smart-entity'
import { useCategories } from 'pages/documents/utilities'
import { size } from 'utilities/object'
import { getListRepresentationFromProfile } from 'utilities/person'
import Form from 'components/form/controller'
import StringField from 'components/form/field/string'
import TextField from 'components/form/field/text'
import SelectField from 'components/form/field/select'
import PersonField from 'components/form/field/person'
import QuickSelect from '../quick-select'
import Actions from 'components/form/actions'
import { Plain, ButtonSubmit } from 'components/button'

const AddSmartDocumentGeneral = ({ form, setForm, concerns, setConcerns, defaultName, back, add, adding, salt }) => {
    const { formatMessage } = useIntl()
    const { entity } = useSmartEntity()
    const { categories } = useCategories()

    return (
        <Form
            layout="vertical"
            onChange={body => setForm(form => ({ ...form, ...body }))}
            onSubmit={add}>
            {({ errors, trigger }) => (
                <>
                    <StringField
                        salt={salt}
                        label={formatMessage({
                            id: 'document_label_name',
                            defaultMessage: 'Name of document'
                        })}
                        name="name"
                        field={{
                            value: form.name ?? defaultName,
                            suffix: '.smart',
                            required: true,
                            include: 'always'
                        }}
                        controlProps={{
                            autoFocus: true,
                            placeholder: defaultName ?? '',
                            max: 255
                        }} />
                    <TextField
                        salt={salt}
                        label={formatMessage({
                            id: 'noun_description',
                            defaultMessage: 'Description'
                        })}
                        name="description"
                        field={{
                            value: form.description,
                            include: 'always'
                        }}
                        controlProps={{
                            placeholder: formatMessage({
                                id: 'description_placeholder',
                                defaultMessage: 'Additional information'
                            }),
                            maxLength: 2040
                        }} />
                    <SelectField
                        salt={salt}
                        label={formatMessage({
                            id: 'noun_category',
                            defaultMessage: 'Category'
                        })}
                        name="category"
                        field={{
                            value: entity?.category ?? form.category,
                            include: !!(entity?.category ?? form.category) ?
                                'always' :
                                'touched',
                            allowEmptyOption: false
                        }}
                        options={categories.map(category => ({
                            ...category,
                            key: category.value
                        }))}
                        enabled={!entity?.category} />
                    <PersonField
                        salt={salt}
                        label={formatMessage({
                            id: 'document_label_regarding',
                            defaultMessage: 'Regarding'
                        })}
                        name="concerns"
                        field={{
                            value: concerns ?
                                getListRepresentationFromProfile(concerns) :
                                null,
                            include: 'always',
                            optional: formatMessage({
                                id: 'document_label_regarding_optional',
                                defaultMessage: 'Optional: Specify who the document regards'
                            })
                        }}
                        picker={{ outer: false }}
                        onChange={({ concerns }) => setConcerns(concerns)}
                        whistle={concerns?.id ?? 'none'} />
                    <QuickSelect
                        types={['user']}
                        values={[concerns ?? null]}
                        insertValue={concerns => setConcerns(concerns)} />
                    <Actions className="compact">
                        <Plain
                            onClick={back}
                            className="neutral"
                            disabled={adding}>
                            <FormattedMessage
                                id="action_back"
                                defaultMessage="Back" />
                        </Plain>
                        <ButtonSubmit
                            className={`constructive${adding ? ' loading' : ''}`}
                            disabled={[
                                !entity,
                                !!size(errors),
                                adding
                            ].some(Boolean)}
                            ref={trigger}>
                            <FormattedMessage
                                id="action_done"
                                defaultMessage="Done" />
                        </ButtonSubmit>
                    </Actions>
                </>
            )}
        </Form>
    )
}

export default AddSmartDocumentGeneral